export default __webpack_public_path__ + "static/media/roadmap-4.25d7b43b.svg";